import { Grid } from "e100-react-components";
import React from "react";
import {
  DistanceCard,
  RefuelingCard,
  SpeedCard,
  TravelTimeCard,
  TruckStop,
} from "./cards";
import {
  DriverStopPeriod,
  useCalculateDriverStopDetails,
} from "entities/navigation";

export const StatisticCards = () => {
  const stopDetails = useCalculateDriverStopDetails();
  const truckStopMore15min = stopDetails.get(DriverStopPeriod.more15min);
  const truckStopMore8h = stopDetails.get(DriverStopPeriod.more8hours);

  return (
    <Grid container>
      <Grid item xs={6}>
        <DistanceCard />
      </Grid>
      <Grid item xs={6}>
        <SpeedCard />
      </Grid>
      <Grid item xs={6}>
        <TravelTimeCard />
      </Grid>
      <Grid item xs={6}>
        <TruckStop
          driverStopItem={truckStopMore15min}
          driverStopPeriod={DriverStopPeriod.more15min}
        />
      </Grid>
      <Grid item xs={6}>
        <TruckStop
          driverStopItem={truckStopMore8h}
          driverStopPeriod={DriverStopPeriod.more8hours}
        />
      </Grid>
      <Grid item xs={6}>
        <RefuelingCard />
      </Grid>
    </Grid>
  );
};
